import { logger } from "../utils";

export class MediaService {
  private static instance: MediaService;

  private constructor() {}

  static getInstance() {
    if (!MediaService.instance) {
      MediaService.instance = new MediaService();
    }
    return MediaService.instance;
  }

  public async getMicrophoneTrack(): Promise<MediaStreamTrack | undefined> {
    try {
      const tracks = await this.getAudioTracks();
      if (tracks && tracks.length) {
        // TODO: two and more microphones
        return tracks[0];
      }
    } catch (error) {
      logger.warn("Failed to get audio tracks", error);
    }
    return undefined;
  }

  public async getCameraTrack(): Promise<MediaStreamTrack | undefined> {
    try {
      const tracks = await this.getVideoTracks();
      if (tracks && tracks.length) {
        // TODO: two and more cameras
        return tracks[0];
      }
    } catch (error) {
      logger.warn("Failed to get video tracks", error);
    }
    return undefined;
  }

  public async getScreenTrack(): Promise<MediaStreamTrack | undefined> {
    try {
      const tracks = await this.getScreenTracks();
      if (tracks && tracks.length) {
        // TODO: two and more screens
        return tracks[0];
      }
    } catch (error) {
      logger.warn("Failed to get screen tracks", error);
    }
    return undefined;
  }

  private async getAudioTracks(): Promise<MediaStreamTrack[]> {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    return stream.getAudioTracks();
  }

  private async getVideoTracks(): Promise<MediaStreamTrack[]> {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    return stream.getVideoTracks();
  }

  private async getScreenTracks(): Promise<MediaStreamTrack[]> {
    const stream = await (navigator.mediaDevices as any).getDisplayMedia({ video: true });
    return stream.getVideoTracks();
  }
}
